import Wrapper from './wrapper';
import { IWrapper } from './types';
import { LanguagesApiResponse } from '../types/language-types';

class Language {
  wrapper: IWrapper;

  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  getLanguages() {
    return this.wrapper.client.get<LanguagesApiResponse, LanguagesApiResponse>(`/languages/`);
  }
}

export default Language;
